<template>
  <ContentSection :spacing="isArticleType ? 'sm-margin' : conditionalSpacing">
    <Container
      :indent="
        isArticleType ? 'none' : isSustainabilityArticle ? 'default' : 'center'
      "
    >
      <!-- TITLE -->
      <h2
        v-if="data.heading"
        class="mb-5 text-xl font-medium sm:mb-6 md:text-2xl"
        v-html="data.heading"
      />
      <!-- LINKS -->
      <AnimatedContainer>
        <ul class="flex flex-col space-y-3 xl:max-w-[66vw]">
          <li v-for="(link, index) in data.links" :key="index" class="fade-in">
            <LinkItem :target="link.target?.value" :to="link.link">
              {{ link.link_text }}
            </LinkItem>
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: () => ({}) },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})

const isNewsArticle = inject('isNewsArticle', null)
const isSustainabilityArticle = inject('isSustainabilityArticle', null)
const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

const isArticleType = computed(
  () => isNewsArticle || isSustainabilityArticleWithSidebar
)

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
  ['custom_text']
)
</script>
